import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, inject, Input, OnInit , signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { AccountService, SubscriptionType } from 'src/app/services/account/account.service';
import { LanguageService } from 'src/app/services/account/language.service';
import { SettingsService } from 'src/app/services/account/settings.service';
import { ImageProcessingService } from 'src/app/services/account/image-processing.service';
import { ConsoleLoggerService } from 'src/app/services/logging/console-logger.service';
import { ProfileDropdownComponent } from '../../profile-dropdown/profile-dropdown.component';
import { SearchComponent } from '../../search/search.component';
import { WidgetSettingsButtonComponent } from '../../ui-components/widget-settings-button/widget-settings-button.component';
import { environment } from 'src/environments/environment';
import { User } from 'src/app/models/user';

@Component({
  standalone: true,
  selector: 'app-header-panel',
  templateUrl: './header-panel.component.html',
  styleUrls: ['./header-panel.component.scss'],
  imports: [CommonModule, SearchComponent, ProfileDropdownComponent, WidgetSettingsButtonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderPanelComponent implements OnInit {

  @Input() loadingMap?: string | null;
  /** Widget mode: no profile button / dropdown, optionally a settings icon instead. */
  @Input() widget: boolean = false;
  @Input() widgetSettings: boolean = true;

  public readonly isAuthorized = signal<boolean>(false);
  public readonly dropdownVisible = signal<boolean>(false);
  public readonly username = signal<string>('');
  public readonly avatarLink = signal<string>('');
  public readonly subscriptionType = signal<SubscriptionType | null>(null);
  public amazonS3BucketUrl: string = environment.AMAZON_S3_BUCKET_URL;

  private readonly destroyRef = inject(DestroyRef);

  constructor(
    public accountService: AccountService,
    private readonly cdr: ChangeDetectorRef,
    public settingsService: SettingsService,
    public languageService: LanguageService,
    private readonly consoleLoggerService: ConsoleLoggerService,
    private readonly imageProcessingService: ImageProcessingService
  ) { }

  ngOnInit(): void {
    this.accountService.ObservableIsAuthorized.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((resp) => {
      if (resp != null && resp != undefined) {
        this.isAuthorized.set(resp);
        if (!resp) {
          this.username.set('');
        }
      }
    });

    this.accountService.ObservableUser.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(async (resp: User | null) => {
      if (resp?.Profile.FirstName) {
        this.username.set(resp.Profile.LastName
          ? resp.Profile.FirstName + ' ' + resp.Profile.LastName
          : resp.Profile.FirstName);
        if (this.accountService.getUserAvatar()) {
          this.avatarLink.set(await this.imageProcessingService.resizeImageUrlToSquare(
            `${this.amazonS3BucketUrl}/${this.accountService.getUserAvatar()}`, 48
          ));
        } else {
          this.avatarLink.set('');
        }
      }
    });


    this.accountService.ObservableSubscriptionType.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((resp) => {
      if (resp) {
        this.subscriptionType.set(resp);
      }
    });
  }

  // Closing on outside presses, entry selection and auth changes is handled by the dropdown itself.
  public profileClick(): void {
    this.dropdownVisible.update(visible => !visible);
  }

}
